<script>
import HeaderCart from 'Vue/Web/Header/HeaderCart.vue';
import HeaderMenu from 'Vue/Web/Header/HeaderMenu.vue';
import NotificationAlert from 'FF/Vue/ControlCenter/Layouts/NotificationAlert/NotificationAlert.vue';
import SocialSideBar from 'Vue/Web/Common/SocialSideBar.vue';

export default {
  el: 'header',
  components: {
    HeaderCart,
    HeaderMenu,
    NotificationAlert,
    SocialSideBar
  },
  props: ['hasNotification'],
  data() {
    return {
      showMenu: false,
      showSearch: false,
      showSearchBar: true,
      showPageMenu: false,
      searchPageType: 'course',
      searchKeyword: '',
    };
  },
  mounted() {
    this.getSearchParams();
  },
  methods: {
    getSearchParams() {
      // 获取当前URL
      let currentURL = window.location.href;

      // 使用正则表达式匹配路径部分
      let match = currentURL.match(/\/search\/(course|product|clinic|article)/);

      // 如果匹配成功，match[1]将包含匹配到的路径部分
      if (match) {
        this.searchPageType = match[1];
        if (this.searchPageType === 'article') {
          this.searchPageType = 'note';
        }
      }
      // 创建URLSearchParams对象并传入当前URL的search部分
      let params = new URLSearchParams(new URL(currentURL).search);
      // 获取参数值
      this.searchKeyword = params.get('keyword');
    },
    openMenu() {
      this.showMenu = true;
    },
    closeMenu() {
      this.showMenu = false;
    },
    toggleSearchBar(){
      this.showSearchBar = !this.showSearchBar;
    },
    toggleShowPageMenu(){
      this.showPageMenu = !this.showPageMenu;
    },
    openSearch() {
      $('.searchBtn').hide();
      $('.searchForm').addClass('open');
      $('.searchClose').show();
      $(
        '.notificationbox, .photobox, .headerCartBox, .header-coursecartbox, .mapBtn, .mobile-icon, .header-logo, .set-icon',
      ).hide();
    },
    closeSearch() {
      $('.searchBtn').show();
      $('.searchForm').removeClass('open');
      $(
        '.notificationbox, .photobox, .headerCartBox, .header-coursecartbox, .mapBtn, .mobile-icon, .header-logo, .set-icon',
      ).show();
    },
  },
};
</script>
